import React, { useState } from 'react'
import styles from './UploadDoc.module.scss'
import { useParams } from 'react-router-dom'
import IconPDF from '@/components/Atoms/Icons/FileTypes/IconPDF'
import IconDOC from '@/components/Atoms/Icons/FileTypes/IconDOC'
import IconXLS from '@/components/Atoms/Icons/FileTypes/IconXLS'
import IconImage from '@/components/Atoms/Icons/FileTypes/IconIMAGE'
import IconFile from '@/components/Atoms/Icons/FileTypes/IconFILE'

import IconCancel from '@/components/Atoms/Icons/IconCancel'
import { Dialog, notifyError } from '@/components'
import { downloadFileFromUrl } from '@/utils/downloadFile'
import { useDeleteFeaturesDocMutation } from './service'
import type { UploadFeaturesDocListItem } from './service'

type Props = {
  documents: UploadFeaturesDocListItem[]
  deviceId?: number
  onDeleted?: (id: UploadFeaturesDocListItem['id']) => void
}

const UploadFeaturesDocList = ({
  documents,
  deviceId: deviceIdProp,
  onDeleted,
}: Props) => {
  const { id: routeDeviceId } = useParams()
  const [deleteDoc] = useDeleteFeaturesDocMutation()
  const [activeId, setActiveId] = useState<
    UploadFeaturesDocListItem['id'] | null
  >(null)
  const [openDialogSave, setOpenDialogSave] = useState(false)

  const effectiveDeviceId =
    deviceIdProp !== undefined ? deviceIdProp : Number(routeDeviceId ?? 0)

  const getFileIcon = (fileName: string) => {
    const extension = fileName.toLowerCase().split('.').pop()
    switch (extension) {
      case 'pdf':
        return <IconPDF />
      case 'doc':
      case 'docx':
        return <IconDOC />
      case 'xls':
      case 'xlsx':
        return <IconXLS />
      case 'png':
      case 'jpg':
      case 'jpeg':
        return <IconImage />
      default:
        return <IconFile />
    }
  }

  const handleDownload = async (url: string, fileName: string) => {
    try {
      await downloadFileFromUrl(url, fileName)
    } catch {
      notifyError('Произошла ошибка при скачивании файла')
    }
  }

  const handleDelete = async () => {
    if (activeId === null) return
    try {
      await deleteDoc({
        deviceId: effectiveDeviceId,
        id: activeId,
      }).unwrap()
      onDeleted?.(activeId)
      setOpenDialogSave(false)
      setActiveId(null)
    } catch {
      notifyError('Ошибка')
    }
  }

  return (
    <div className={styles.Wrapper}>
      <Dialog
        message='Документ будет удален. Вы уверены?'
        open={openDialogSave}
        handleClose={() => setOpenDialogSave(false)}
        handleAgree={handleDelete}
      />
      {documents.map((item) => {
        const hasUrl = 'url' in item && item.url
        return (
          <div
            key={String(item.id)}
            className={styles.Item}
            onClick={() => {
              if (hasUrl) handleDownload(item.url, item.name)
            }}
            style={{ cursor: hasUrl ? 'pointer' : 'default' }}
          >
            <span
              className={styles.IconDelete}
              onClick={(e) => {
                e.stopPropagation()
                setActiveId(item.id)
                setOpenDialogSave(true)
              }}
            >
              <IconCancel />
            </span>
            {getFileIcon(item.name)}
            <p className={styles.Text}>{item.name}</p>
          </div>
        )
      })}
    </div>
  )
}

export default UploadFeaturesDocList
